module.exports = __webpack_public_path__ + "img/package-2.b67555ec.png";